import axios from "./axios-handler.service";
import { Paginacao } from "@/shared/interface";
const BASE_URL = "/api/MensagemPronta";

export interface MensagemPronta {
  idMensagemPronta: number;
  idMensagemOcta: string;
  tituloMensagem: string;
}

export interface Filtro {
  term: string;
  offset: number;
  limit: number;
  order?: string;
}

export class MensagemProntaService {
  static async obter(idMensagemPronta: number): Promise<MensagemPronta> {
    const response = await axios.get<MensagemPronta>(
      `${BASE_URL}/obter/${idMensagemPronta}`
    );
    return response.data;
  }

  static async obterMensagemPronta(): Promise<MensagemPronta[]> {
    const response = await axios.get<any[]>(`${BASE_URL}/ObterMensagemPronta`);
    return response.data;
  }

  static async listarMensagensProntas(
    filtro: Filtro
  ): Promise<Paginacao<MensagemPronta>> {
    const { term, offset, limit, order } = filtro;
    const response = await axios.get<Paginacao<MensagemPronta>>(
      `${BASE_URL}/ListarMensagensProntas`,
      {
        params: {
          txtPesquisa: term,
          offset,
          limit,
          order,
        },
      }
    );
    return response.data;
  }

  static async manterMensagemPronta(
    mensagemPronta: MensagemPronta
  ): Promise<void> {
    const {
      idMensagemPronta,
      idMensagemOcta,
      tituloMensagem: titulo,
    } = mensagemPronta;
    await axios.post(BASE_URL + "/ManterMensagens", {
      idMensagemPronta,
      idMensagemOcta,
      titulo,
    });
  }

  static async excluirMensagem(idMensagemPronta: number): Promise<void> {
    await axios.delete<void>(BASE_URL + "/excluirMensagem/" + idMensagemPronta);
  }
}
